// ============ تنسيق الأسعار بالدرهم لكل لغة ============
// en: AED 1.96M · ar: ١٫٩٦ مليون د.إ · ru: 1,96 млн AED · de: 1,96 Mio. AED · fr/es: 1,96 M AED · it: 1,96 Mln AED · he: 1.96M AED · zh: 196万 迪拉姆
export const formatAED = (v, locale, lang, { compact = true } = {}) => {
  if (typeof v !== "number" || !Number.isFinite(v)) return null;
  const n = new Intl.NumberFormat(locale, {
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: compact ? 2 : 0,
  }).format(v);
  if (lang === "ar") return `${n} د.إ`;
  if (lang === "zh") return `${n} 迪拉姆`;
  if (lang === "en") return `AED ${n}`;
  return `${n} AED`;
};
